import React, { useState } from 'react'
import Classes from './Dashboard.module.css'
import ColumnChart from './Comp/ColumnChart'
import { styled } from '@mui/material/styles';
import Stack from '@mui/material/Stack';
import LinearProgress, { linearProgressClasses } from '@mui/material/LinearProgress';
import { AnimatePresence } from 'framer-motion';
import OnBoardingSuccessPopup from '../../../../GlobalComponents/OnBoardingSuccessPopup/OnBoardingSuccessPopup';
import DropDown from './StatusDropDown/DropDown';
import { DateRange } from '@mui/icons-material';
import MyDateRange from './Comp/MyDateRange';

const BorderLinearProgress = styled(LinearProgress)(({ theme }) => ({
  height: 10,
  borderRadius: 5,
  width: '10vw',
  [`&.${linearProgressClasses.colorPrimary}`]: {
    backgroundColor: theme.palette.grey[200],
    ...theme.applyStyles('dark', {
      backgroundColor: theme.palette.grey[800],
    }),
  },
  [`& .${linearProgressClasses.bar}`]: {
    borderRadius: 5,
    backgroundColor: '#1a90ff',
    ...theme.applyStyles('dark', {
      backgroundColor: '#308fe8',
    }),
  },
}));

const ClientsIcon = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" {...props} viewBox="0 0 448 512"><path d="M224 256A128 128 0 1 0 224 0a128 128 0 1 0 0 256zm-45.7 48C79.8 304 0 383.8 0 482.3C0 498.7 13.3 512 29.7 512l388.6 0c16.4 0 29.7-13.3 29.7-29.7C448 383.8 368.2 304 269.7 304l-91.4 0z" /></svg>
)

const DollarIcon = (props) => (
  <>
    <svg xmlns="http://www.w3.org/2000/svg" {...props} viewBox="0 0 320 512"><path d="M160 0c17.7 0 32 14.3 32 32l0 35.7c1.6 .2 3.1 .4 4.7 .7c.4 .1 .7 .1 1.1 .2l48 8.8c17.4 3.2 28.9 19.9 25.7 37.2s-19.9 28.9-37.2 25.7l-47.5-8.7c-31.3-4.6-58.9-1.5-78.3 6.2s-27.2 18.3-29 28.1c-2 10.7-.5 16.7 1.2 20.4c1.8 3.9 5.5 8.3 12.8 13.2c16.3 10.7 41.3 17.7 73.7 26.3l2.9 .8c28.6 7.6 63.6 16.8 89.6 33.8c14.2 9.3 27.6 21.9 35.9 39.5c8.5 17.9 10.3 37.9 6.4 59.2c-6.9 38-33.1 63.4-65.6 76.7c-13.7 5.6-28.6 9.2-44.4 11l0 33.4c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-34.9c-.4-.1-.9-.1-1.3-.2l-.2 0s0 0 0 0c-24.4-3.8-64.5-14.3-91.5-26.3c-16.1-7.2-23.4-26.1-16.2-42.2s26.1-23.4 42.2-16.2c20.9 9.3 55.3 18.5 75.2 21.6c31.9 4.7 58.2 2 76-5.3c16.9-6.9 24.6-16.9 26.8-28.9c1.9-10.6 .4-16.7-1.3-20.4c-1.9-4-5.6-8.4-13-13.3c-16.4-10.7-41.5-17.7-74-26.3l-2.8-.7s0 0 0 0C119.4 279.3 84.4 270 58.4 253c-14.2-9.3-27.5-22-35.8-39.6c-8.4-17.9-10.1-37.9-6.1-59.2C23.7 116 52.3 91.2 84.8 78.3c13.3-5.3 27.9-8.9 43.2-11L128 32c0-17.7 14.3-32 32-32z" /></svg>
  </>
)

const ChurnIcon = (props) => (
  <>
    <svg xmlns="http://www.w3.org/2000/svg" {...props} viewBox="0 0 512 512"><path d="M352 256c0 22.2-1.2 43.6-3.3 64l-185.3 0c-2.2-20.4-3.3-41.8-3.3-64s1.2-43.6 3.3-64l185.3 0c2.2 20.4 3.3 41.8 3.3 64zm28.8-64l123.1 0c5.3 20.5 8.1 41.9 8.1 64s-2.8 43.5-8.1 64l-123.1 0c2.1-20.6 3.2-42 3.2-64s-1.1-43.4-3.2-64zm112.6-32l-116.7 0c-10-63.9-29.8-117.4-55.3-151.6c78.3 20.7 142 77.5 171.9 151.6zm-149.1 0l-176.6 0c6.1-36.4 15.5-68.6 27-94.7c10.5-23.6 22.2-40.7 33.5-51.5C239.4 3.2 248.7 0 256 0s16.6 3.2 27.8 13.8c11.3 10.8 23 27.9 33.5 51.5c11.6 26 20.9 58.2 27 94.7zm-209 0L18.6 160C48.6 85.9 112.2 29.1 190.6 8.4C165.1 42.6 145.3 96.1 135.3 160zM8.1 192l123.1 0c-2.1 20.6-3.2 42-3.2 64s1.1 43.4 3.2 64L8.1 320C2.8 299.5 0 278.1 0 256s2.8-43.5 8.1-64zM194.7 446.6c-11.6-26-20.9-58.2-27-94.6l176.6 0c-6.1 36.4-15.5 68.6-27 94.6c-10.5 23.6-22.2 40.7-33.5 51.5C272.6 508.8 263.3 512 256 512s-16.6-3.2-27.8-13.8c-11.3-10.8-23-27.9-33.5-51.5zM135.3 352c10 63.9 29.8 117.4 55.3 151.6C112.2 482.9 48.6 426.1 18.6 352l116.7 0zm358.1 0c-30 74.1-93.6 130.9-171.9 151.6c25.5-34.2 45.2-87.7 55.3-151.6l116.7 0z" /></svg>
  </>
)

const TeamIcon = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" {...props} viewBox="0 0 640 512"><path d="M96 128a128 128 0 1 1 256 0A128 128 0 1 1 96 128zM0 482.3C0 383.8 79.8 304 178.3 304l91.4 0C368.2 304 448 383.8 448 482.3c0 16.4-13.3 29.7-29.7 29.7L29.7 512C13.3 512 0 498.7 0 482.3zM609.3 512l-137.8 0c5.4-9.4 8.6-20.3 8.6-32l0-8c0-60.7-27.1-115.2-69.8-151.8c2.4-.1 4.7-.2 7.1-.2l61.4 0C567.8 320 640 392.2 640 481.3c0 17-13.8 30.7-30.7 30.7zM432 256c-31 0-59-12.6-79.3-32.9C372.4 196.5 384 163.6 384 128c0-26.8-6.6-52.1-18.3-74.3C384.3 40.1 407.2 32 432 32c61.9 0 112 50.1 112 112s-50.1 112-112 112z" /></svg>
)

const ServicesIcon = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" {...props} viewBox="0 0 576 512"><path d="M264.5 5.2c14.9-6.9 32.1-6.9 47 0l218.6 101c8.5 3.9 13.9 12.4 13.9 21.8s-5.4 17.9-13.9 21.8l-218.6 101c-14.9 6.9-32.1 6.9-47 0L45.9 149.8C37.4 145.8 32 137.3 32 128s5.4-17.9 13.9-21.8L264.5 5.2zM476.9 209.6l53.2 24.6c8.5 3.9 13.9 12.4 13.9 21.8s-5.4 17.9-13.9 21.8l-218.6 101c-14.9 6.9-32.1 6.9-47 0L45.9 277.8C37.4 273.8 32 265.3 32 256s5.4-17.9 13.9-21.8l53.2-24.6 152 70.2c23.4 10.8 50.4 10.8 73.8 0l152-70.2zm-152 198.2l152-70.2 53.2 24.6c8.5 3.9 13.9 12.4 13.9 21.8s-5.4 17.9-13.9 21.8l-218.6 101c-14.9 6.9-32.1 6.9-47 0L45.9 405.8C37.4 401.8 32 393.3 32 384s5.4-17.9 13.9-21.8l53.2-24.6 152 70.2c23.4 10.8 50.4 10.8 73.8 0z" /></svg>
)

const WorkspaceIcon = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" {...props} viewBox="0 0 448 512"><path d="M0 96C0 78.3 14.3 64 32 64l384 0c17.7 0 32 14.3 32 32s-14.3 32-32 32L32 128C14.3 128 0 113.7 0 96zM0 256c0-17.7 14.3-32 32-32l384 0c17.7 0 32 14.3 32 32s-14.3 32-32 32L32 288c-17.7 0-32-14.3-32-32zM448 416c0 17.7-14.3 32-32 32L32 448c-17.7 0-32-14.3-32-32s14.3-32 32-32l384 0c17.7 0 32 14.3 32 32z" /></svg>
)

const HeadphoneIcon = (props) => (
  <>
    <svg xmlns="http://www.w3.org/2000/svg" {...props} viewBox="0 0 320 512"><path d="M160 0c17.7 0 32 14.3 32 32l0 35.7c1.6 .2 3.1 .4 4.7 .7c.4 .1 .7 .1 1.1 .2l48 8.8c17.4 3.2 28.9 19.9 25.7 37.2s-19.9 28.9-37.2 25.7l-47.5-8.7c-31.3-4.6-58.9-1.5-78.3 6.2s-27.2 18.3-29 28.1c-2 10.7-.5 16.7 1.2 20.4c1.8 3.9 5.5 8.3 12.8 13.2c16.3 10.7 41.3 17.7 73.7 26.3l2.9 .8c28.6 7.6 63.6 16.8 89.6 33.8c14.2 9.3 27.6 21.9 35.9 39.5c8.5 17.9 10.3 37.9 6.4 59.2c-6.9 38-33.1 63.4-65.6 76.7c-13.7 5.6-28.6 9.2-44.4 11l0 33.4c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-34.9c-.4-.1-.9-.1-1.3-.2l-.2 0s0 0 0 0c-24.4-3.8-64.5-14.3-91.5-26.3c-16.1-7.2-23.4-26.1-16.2-42.2s26.1-23.4 42.2-16.2c20.9 9.3 55.3 18.5 75.2 21.6c31.9 4.7 58.2 2 76-5.3c16.9-6.9 24.6-16.9 26.8-28.9c1.9-10.6 .4-16.7-1.3-20.4c-1.9-4-5.6-8.4-13-13.3c-16.4-10.7-41.5-17.7-74-26.3l-2.8-.7s0 0 0 0C119.4 279.3 84.4 270 58.4 253c-14.2-9.3-27.5-22-35.8-39.6c-8.4-17.9-10.1-37.9-6.1-59.2C23.7 116 52.3 91.2 84.8 78.3c13.3-5.3 27.9-8.9 43.2-11L128 32c0-17.7 14.3-32 32-32z" /></svg>
  </>
)

export default function Dashboard({ showAgencyRoutes, setShowAgencyRoutes }) {
  const [onBoardingSuccessPopup, setonBoardingSuccessPopup] = useState(true);
  const handleCloseOnboardingSuccessPopup = () => {
    setonBoardingSuccessPopup(false);
  }

  const [reports, setreports] = useState('');

  return (
    <>
      <AnimatePresence>
        {onBoardingSuccessPopup && (
          <OnBoardingSuccessPopup closePopup={handleCloseOnboardingSuccessPopup} />
        )}
      </AnimatePresence>

      <div className={Classes.hero} >
        <div className={Classes.grid} >
          <div className={Classes.gridLeft} >
            <div className={Classes.banner} >
              {/* <div className={Classes.flexAlign10} >
                <div className={Classes.datePicker} style={{ padding: '0 10px' }} >
                  <h5>Mar 3, 2025 to Mar 9, 2025</h5>
                </div>
                <div className={Classes.datePicker} >
                  <svg xmlns="http://www.w3.org/2000/svg" height='13px' width='16px' viewBox="0 0 448 512"><path d="M96 32l0 32L48 64C21.5 64 0 85.5 0 112l0 48 448 0 0-48c0-26.5-21.5-48-48-48l-48 0 0-32c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 32L160 64l0-32c0-17.7-14.3-32-32-32S96 14.3 96 32zM448 192L0 192 0 464c0 26.5 21.5 48 48 48l352 0c26.5 0 48-21.5 48-48l0-272z" /></svg>
                </div>
              </div> */}
              <MyDateRange />
              <div className={Classes.flexAlign10} >
                <DropDown
                  selectedValue={reports}
                  options={["Revenue", "Clients", "Churn", "Completed Orders"]}
                  onChange={(val) => { setreports(val) }}
                  isDropDown={true}
                />
                <div className={Classes.exportBtn} >
                  <h5>Export</h5>
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path d="M288 32c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 242.7-73.4-73.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l128 128c12.5 12.5 32.8 12.5 45.3 0l128-128c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L288 274.7 288 32zM64 352c-35.3 0-64 28.7-64 64l0 32c0 35.3 28.7 64 64 64l384 0c35.3 0 64-28.7 64-64l0-32c0-35.3-28.7-64-64-64l-101.5 0-45.3 45.3c-25 25-65.5 25-90.5 0L165.5 352 64 352zm368 56a24 24 0 1 1 0 48 24 24 0 1 1 0-48z" /></svg>
                </div>
              </div>
            </div>
            <div className={Classes.hero1} >
              <div className={Classes.heroBox} >
                <div className={Classes.hero1Img} style={{ background: "#3e9bff" }} >
                  <DollarIcon height='27px' width='27px' fill='white' />
                </div>
                <div>
                  <h5>Revenue</h5>
                  <h3>
                    $9,613
                  </h3>
                </div>
              </div>
              <div className={Classes.miniLine} ></div>
              <div className={Classes.heroBox} >
                <div className={Classes.hero1Img} style={{ background: "#3e9bff" }} >
                  <ClientsIcon height='27px' width='27px' fill='white' />
                </div>
                <div>
                  <h5>New Clients</h5>
                  <h3>
                    77
                  </h3>
                </div>
              </div>
              <div className={Classes.miniLine} ></div>
              <div className={Classes.heroBox} >
                <div className={Classes.hero1Img} style={{ background: "#3e9bff" }} >
                  <ChurnIcon height='27px' width='27px' fill='white' />
                </div>
                <div>
                  <h5>Churn</h5>
                  <h3>
                    10%
                  </h3>
                </div>
              </div>
            </div>
            <div className={Classes.graphCon} >
              <div>
                <h5 className={Classes.titleLight} >Revenue</h5>
                <h3> $9,452 </h3>
              </div>
              <hr />
              <ColumnChart />
            </div>
            <p className={Classes.lightTextMini} >All times in 0 timezone. Data updated 30 minutes ago.</p>
          </div>
          <div className={Classes.gridRight} >
            <div className={Classes.progressBar} >

              <div className={Classes.progressHeader} >
                <h3>Tasks</h3>
                <div className={Classes.flexAlign10} >
                  <Stack spacing={2} sx={{ flexGrow: 1 }}>
                    <BorderLinearProgress variant="determinate" value={25} />
                  </Stack>
                  <h5>1 / 4</h5>
                </div>
              </div>

              <div className={Classes.actions} >
                <hr className={Classes.actionLine} />

                <div className={Classes.action} >
                  <div className={Classes.actionBoxBg} >
                    <div className={`${Classes.actionBox} ${Classes.taskDone}`} >
                      <TeamIcon height='20px' width='20px' fill='#cccccc' />
                    </div>
                  </div>
                  <div className={Classes.actiontext} style={{ opacity: '0.4' }} >
                    <h4>Invite team members</h4>
                    <h5>Invite other team members to your dashboard.</h5>
                    <button> <h4>Invite team</h4> </button>
                  </div>
                </div>

                <div className={Classes.action} >
                  <div className={Classes.actionBoxBg} >
                    <div className={Classes.actionBox} >
                      <DollarIcon height='20px' width='20px' fill='#3E9BFF' />
                    </div>
                  </div>
                  <div className={Classes.actiontext} >
                    <h4>Connect your payment processor</h4>
                    <h5>You’ll be using your own Stripe or PayPal account
                      to accept payments. We never charge transaction
                      fees on your sales.</h5>
                    <button> <h4>Payment processors</h4> </button>
                  </div>
                </div>

                <div className={Classes.action} >
                  <div className={Classes.actionBoxBg} >
                    <div className={Classes.actionBox} >
                      <ServicesIcon height='20px' width='20px' fill='#3E9BFF' />
                    </div>
                  </div>
                  <div className={Classes.actiontext} >
                    <h4>Add a new service</h4>
                    <h5>You can sell one-off or recurring services
                      through Anchorize.</h5>
                    <button> <h4>Go to services</h4> </button>
                  </div>
                </div>

                <div className={Classes.action} >
                  <div className={Classes.actionBoxBg} >
                    <div className={Classes.actionBox} >
                      <WorkspaceIcon height='20px' width='20px' fill='#3E9BFF' />
                    </div>
                  </div>
                  <div className={Classes.actiontext} >
                    <h4>Add a new onboarding form</h4>
                    <h5>Customize your onboarding process for
                      new clients.</h5>
                    <button> <h4>Go to forms</h4> </button>
                  </div>
                </div>
              </div>

              <hr className={Classes.splitAction} />

              <div className={Classes.action} >
                <div className={Classes.actionBox} >
                  <HeadphoneIcon height='20px' width='20px' fill='#3E9BFF' />
                </div>
                <div className={Classes.actiontext} >
                  <h4>Schedule a free demo call</h4>
                  <h5>We’ll show you what’s possible and help you
                    understand if Anchorize is a good fit for your
                    agency.</h5>
                  <button style={{ width: '80%', height: '2rem' }} > <h4>Book call</h4> </button>
                </div>
              </div>

            </div>
          </div>
        </div>
      </div>
    </>
  )
}
